import { Redirect, useHistory, useParams } from "react-router";

const withAuth = Component => props => {
  const history = useHistory();
  const isAuth = JSON.parse(localStorage.getItem("user-login-status"));

  const lastLocation = history.location.pathname;
  const avoidRedirection = window.location.pathname === '/login' || window.location.pathname === '/logout';;
  if (isAuth) {
    return <Component {...props} />;
  } else {
      return <Redirect {...props} to={`/login${(avoidRedirection) ? '' : '/redirectTo='+lastLocation}`} />;
     }
  };

export default withAuth;